module.exports = __webpack_public_path__ + "img/process_3.652199ee.png";